import React, { useEffect } from 'react';

export default function MaintenancePage() {
    useEffect(() => {
        const originalStyle = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            fontFamily: "circe-rounded",
            alignItems: 'center',
            textAlign: 'center',
            padding: '0 20px',
            color: "#707070",
        }}>
            <div style={{ fontSize: '80px', marginBottom: '20px' }}>⚙️⚙️</div>
            <h1>Site is under maintenance</h1>
            <p>We're working hard to improve the user experience. Stay tuned!</p>
        </div>
    );
}